<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-sort
    v-model="selectedItemIds"
    data-url="admin/contract/year/"
    :extra-params="{ contract_id: contractId }"
    data-key="years"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    hide-default-footer
    class="contract-year-list"
  >
    <template #item.percentage_excel="{ value }">
      {{ value.filename }}
    </template>
    <template #item.finalised_at="{ value }">
      <span :class="[{ finalised: value }, 'contract-finalised-span']">{{
        value ? "Finalised" : "In Progress"
      }}</span>
    </template>
    <template #item.updated_at="{ value }">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex" style="justify-content: center; align-items: center">
        <v-btn
          v-if="!item.finalised_at && canManageContract && !item.old_version"
          text
          color="primary"
          @click="editFluctuation(item)"
        >
          Fluctuation
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$downloadFile(item.percentage_excel.id)"
        >
          EXCEL
        </v-btn>
        <v-btn
          text
          color="primary"
          v-if="!item.finalised_at && canManageContract"
          @click="deleteItem(item)"
        >
          DELETE
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="!item.finalised_at && canManageContract"
          @click="finaliseItem(item)"
        >
          {{ $t("sor.finalise") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          class="ml-4"
          v-if="item.finalised_at"
          @click="exportBmsExcel(item)"
        >
          {{ $t("sor.export_bms_excel") }}
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "ContractYearList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,

    contractId: String,
    contract: Object,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };

    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      {
        text: root.$t("contract_year.updated_at"),
        value: "updated_at",
        width: 200,
        sortable: false,
      },
      { text: root.$t("contract_year.year"), value: "year", width: 150 },
      {
        text: root.$t("contract_year.percentage_excel"),
        value: "percentage_excel",
      },
      {
        text: root.$t("contract_year.finalised_at"),
        value: "finalised_at",
        width: 150,
        sortable: false,
      },
      { text: "", value: "actions", sortable: false, width: 250 },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    // const haveSpecialPermission = computed(() => {
    //   return root.$store.getters.hasSpecialPermission(
    //     SPECIAL_PERMISSIONS.CONTRACT_PERCENTAGE_FLUCTUATION
    //   );
    // });

    const editItem = async function (item) {
      root.$router.push({ name: "sor-detail", params: { sorId: item.id } });
    };
    const exportPdf = async function (item) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/section/export_pdf/",
        params: {
          section_id: item.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${item.name}.pdf`;
      link.click();
    };
    const deleteItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: root.$t("contract_year.delete_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/year/delete/",
          params: { year_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };
    const finaliseItem = async function (item) {
      if (
        await root.$dialog.confirm({
          text: root.$t("contract_year.finalise_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/year/finalise/",
          params: { year_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };
    const exportBmsExcel = async function (item) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/year/export_bms/",
        params: { year_id: item.id },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let disposition = response.headers.get("Content-Disposition");
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      let filename = matches[1].replace(/['"]/g, "");

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURIComponent(filename);
      link.click();
    };

    const editFluctuation = async function (item) {
      root.$router.push({
        name: "contract-percentage-list",
        params: {
          contractId: props.contractId,
          contract_percentage_id: item.id,
        },
      });
    };

    const canManageContract = computed(() => {
      if (props.contract) {
        return (
          root.$store.getters.hasPermission(null) ||
          _.some(
            props.contract.admins,
            (a) => a.account.id === root.$store.getters.account.id
          )
        );
      }

      return false;
    });

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      exportPdf,
      deleteItem,
      finaliseItem,
      exportBmsExcel,
      editFluctuation,
      canManageContract,
      // haveSpecialPermission,
    };
  },
};
</script>

<style lang="less">
.contract-list {
  .contract-finalised-span {
    color: rgba(108, 117, 125, 0.6);

    &.finalised {
      color: #5bc23f;
    }
  }
}
</style>
